import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class HandleErrorService {
	constructor(private toaster: ToastrService) {}

	public handleError(err: HttpErrorResponse) {
		let errorMessage: string;

		if (err.error instanceof ErrorEvent) {
			errorMessage = `Ocorreu um erro: ${err.error.message}`;
		} else {
			switch (err.status) {
				case 400:
					errorMessage = `Requisição inválida.`;
					this.toaster.error(errorMessage);
					break;
				case 401:
					errorMessage = `Não autorizado.`;
					this.toaster.error(errorMessage);
					break;
				case 403:
					errorMessage = `Você não tem permissão para acessar o recurso solicitado.`;
					this.toaster.error(errorMessage);
					break;
				case 404:
					errorMessage = `Dados não encontrados para o filtro informado.`;
					this.toaster.warning(errorMessage);
					break;
				case 412:
					errorMessage = `Pré-condição falhou.`;
					this.toaster.error(errorMessage);
					break;
				case 500:
					errorMessage = `Erro no servidor.`;
					this.toaster.error(errorMessage);
					break;
				case 503:
					errorMessage = `O serviço de solicitação não está disponível.`;
					this.toaster.error(errorMessage);
					break;
				default:
					console.log(err)
			}
		}
	}
}
